import axiosInstance from './axiosInstance';

/**
 * winnowingApi.js
 *
 * API helpers for the Winnowing plagiarism analytics dashboard.
 * Isolated from the rest of api.js per the winnowingEngine isolation constraint.
 */

/**
 * Fetch paginated plagiarism analytics results.
 *
 * @param {object} params
 * @param {number} [params.page=1]
 * @param {number} [params.limit=25]
 * @param {string} [params.problemSlug]  Optional problem filter.
 * @param {string} [params.student]      Optional substring match on student names.
 * @param {boolean}[params.flagged]      If true, return only flagged results.
 * @param {string} [params.sortBy]       'similarityScore' | 'checkedAt'
 * @param {string} [params.sortDir]      'asc' | 'desc'
 * @returns {Promise<{ results, total, page, limit, pages }>}
 */
export const getWinnowingAnalytics = (params = {}) => {
  const query = new URLSearchParams();
  if (params.page)        query.set('page',        params.page);
  if (params.limit)       query.set('limit',       params.limit);
  if (params.problemSlug) query.set('problemSlug', params.problemSlug);
  if (params.student)     query.set('student',     params.student);
  if (params.flagged)     query.set('flagged',     'true');
  if (params.sortBy)      query.set('sortBy',      params.sortBy);
  if (params.sortDir)     query.set('sortDir',     params.sortDir);
  if (params.batchId)     query.set('batchId',     params.batchId);
  return axiosInstance.get(`/winnowing/analytics?${query.toString()}`);
};

/**
 * Fetch the raw source code for both students for a given problem.
 *
 * @param {string} studentA
 * @param {string} studentB
 * @param {string} problemSlug
 * @returns {Promise<{ studentA: {username,code,language,submittedAt}, studentB: {...} }>}
 */
export const getComparisonCode = (studentA, studentB, problemSlug) =>
  axiosInstance.get('/winnowing/analytics/code', {
    params: { studentA, studentB, problemSlug },
  });
